import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppMenuSyncService {

  private syncSubject = new BehaviorSubject<any>(null);  // For synchronization
  AIAGentDashboardList: any = [];
  AIAGentList: any = [];
  
  syncAppMenu(data: any) {
    this.syncSubject.next(data);  // Update sync data
  }

  getSyncUpdates() {
    return this.syncSubject.asObservable();  // Return an observable for updates
  }
  
}
